/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from 'react';
import { MyAccountContext } from '../../../providers/MyAccountProvider';
import { DepartmentInfoComponent } from './CommonMyAccountComponents';

const ProviderMyAccount = () => {
  const myAccountContext = useContext(MyAccountContext);
  const currentUser = myAccountContext.currentUserType;

  return (
    <>
      <DepartmentInfoComponent departments={currentUser.department_id} />
    </>
  );
};

export default ProviderMyAccount;
